import React from 'react'
import { useParams } from 'react-router-dom'
import { LoadingArea } from '@unbounded/unbounded-components'
import { GetConsortiumBySlugQuery, GetConsortiumBySlugQueryVariables, useGetConsortiumBySlugLazyQuery } from '~api/queries/consortiums.generated'
import Layout from '~layout'
import Breadcrumbs, { Breadcrumb } from '~components/Breadcrumbs'
import { StyledDetails, useDetailsLazyQuery } from '~components/Details'
import ConsortiumDetails from './ConsortiumDetails'
import Paths from '~routes/paths'

type ConsortiumDetailsParams = {
  slug: string
}

const ConsortiumDetailsContainer: React.FC = () => {
  const { slug = '' } = useParams<ConsortiumDetailsParams>()

  const {
    data: { consortium },
    isLoading,
  } = useDetailsLazyQuery<GetConsortiumBySlugQuery, GetConsortiumBySlugQueryVariables>({
    useLazyQuery: useGetConsortiumBySlugLazyQuery,
    variables: {
      slug,
    },
  })

  return (
    <Layout>
      <Layout.Content>
        <Breadcrumbs>
          <Breadcrumb title="Consortiums" path={Paths.consortiums} />
          <Breadcrumb title={consortium?.name || 'View a consortium'} />
        </Breadcrumbs>

        <LoadingArea isLoading={isLoading} placeholder="Loading consortium...">
          {consortium ? (
            <StyledDetails.Container>
              <ConsortiumDetails consortium={consortium} />
            </StyledDetails.Container>
          ) : (
            <StyledDetails.Placeholder>Sorry, could not find consortium with specified id</StyledDetails.Placeholder>
          )}
        </LoadingArea>
      </Layout.Content>
    </Layout>
  )
}

export default ConsortiumDetailsContainer
